import { ACTION } from "@/lib/auth/actions";
import { ROLE } from "@/lib/auth/roles";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Màn "Hiệu suất quản lý" (CEO chốt 6a, 28/10/2026): giám đốc, quản trị, quản
 * lý cụm, trưởng cửa hàng — một quyền `mgmtperf.read`; phạm vi do MÁY CHỦ cắt.
 */
export function canSeeMgmtPerformance(): boolean {
  return hasPermission(ACTION.MgmtPerfRead);
}

/** Trưởng cửa hàng chỉ có góc nhìn của mình (CEO chốt 5b). */
export function isStoreLeadView(role: string | null | undefined): boolean {
  return (role || "").toLowerCase().trim() === ROLE.BranchManager;
}
